<template>
  <div class="bg-gray-700 rounded-t-none rounded-lg pb-2">
    <div class="bg-gray-800 py-2">
      <div class="px-3 py-1 pb-2">Nombre limité par participants</div>
      <div class="flex justify-between py-2 border-t border-b border-gray-600">
        <Toggle
          class="w-full px-3"
          name="isAttendeesContributionsLimitByLabel"
          title="Par label"
          on="OK"
          off="No"
          :checked="question.isAttendeesContributionsLimitByLabel"
          @toggle="toggleIsAttendeesContributionsLimitByLabel"
        />
      </div>
      <div v-if="!showOtherAttenteesInput" class="flex justify-between px-4 py-4">
        <div @click="setAttendeesContributionsLimit('free')" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.attendeesContributionsLimit === 'free'"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributionsFreeOn.svg"
            alt="Contributions free on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributionsFreeOff.svg"
            alt="Contributions free off"
          />
          <div class="pt-1" :class="[question.attendeesContributionsLimit === 'free' ? 'text-white' : 'text-gray-600']">
            Libre
          </div>
        </div>
        <div @click="setAttendeesContributionsLimit(1)" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.attendeesContributionsLimit === 1"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions1On.svg"
            alt="Contributions 1 on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions1Off.svg"
            alt="Contributions 1 off"
          />
          <div class="pt-1" :class="[question.attendeesContributionsLimit === 1 ? 'text-white' : 'text-gray-600']">
            1
          </div>
        </div>
        <div @click="showOtherAttenteesInput = true" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="!['free', 1, 3, 5, 10].includes(question.attendeesContributionsLimit)"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributionsOtherOn.svg"
            alt="Contributions Other on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributionsOtherOff.svg"
            alt="Contributions Other off"
          />
          <div
            class="pt-1"
            :class="[
              !['free', 1, 3, 5, 10].includes(question.attendeesContributionsLimit) ? 'text-white' : 'text-gray-600',
            ]"
          >
            Autre
          </div>
        </div>
      </div>
      <div v-if="!showOtherAttenteesInput" class="flex justify-between px-4 pb-2">
        <div @click="setAttendeesContributionsLimit(3)" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.attendeesContributionsLimit === 3"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions3On.svg"
            alt="Contributions 3 on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions3Off.svg"
            alt="Contributions 3 off"
          />
          <div class="pt-1" :class="[question.attendeesContributionsLimit === 3 ? 'text-white' : 'text-gray-600']">
            3
          </div>
        </div>
        <div @click="setAttendeesContributionsLimit(5)" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.attendeesContributionsLimit === 5"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions5On.svg"
            alt="Contributions 5 on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions5Off.svg"
            alt="Contributions 5 off"
          />
          <div class="pt-1" :class="[question.attendeesContributionsLimit === 5 ? 'text-white' : 'text-gray-600']">
            5
          </div>
        </div>
        <div @click="setAttendeesContributionsLimit(10)" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.attendeesContributionsLimit === 10"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions10On.svg"
            alt="Contributions 10 on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions10Off.svg"
            alt="Contributions 10 off"
          />
          <div class="pt-1" :class="[question.attendeesContributionsLimit === 10 ? 'text-white' : 'text-gray-600']">
            10
          </div>
        </div>
      </div>
      <div v-else class="pt-3 px-5">
        Limite
        <input
          v-model="attendeesOther"
          ref="attendeesOther"
          class="w-28 px-2 bg-gray-800 text-white focus:outline-none placeholder-gray-600"
          type="text"
          placeholder="Nombre"
        />
        <img
          class="w-6 h-6 inline-block mr-4 cursor-pointer"
          src="../../assets/icons/edit.svg"
          alt="Valider"
          @click="
            setAttendeesContributionsLimit(parseInt(attendeesOther))
            showOtherAttenteesInput = false
          "
        />
        <img
          class="w-4 h-4 inline-block cursor-pointer"
          src="../../assets/icons/close.svg"
          alt="Annuler"
          @click="showOtherAttenteesInput = false"
        />
      </div>
    </div>
    <div class="bg-gray-700 pt-2">
      <div class="px-3 py-1 pb-2">Nombre limité par question</div>
      <div class="flex justify-between py-2 border-t border-b border-gray-600">
        <Toggle
          class="w-full px-3"
          name="isQuestionContributionsLimitByLabel"
          title="Par label"
          on="OK"
          off="No"
          :checked="question.isQuestionContributionsLimitByLabel"
          @toggle="toggleIsQuestionContributionsLimitByLabel"
        />
      </div>
      <div v-if="!showOtherQuestionInput" class="flex justify-between px-4 py-4">
        <div @click="setQuestionContributionsLimit('free')" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.questionContributionsLimit === 'free'"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributionsFreeOn.svg"
            alt="Contributions free on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributionsFreeOff.svg"
            alt="Contributions free off"
          />
          <div class="pt-1" :class="[question.questionContributionsLimit === 'free' ? 'text-white' : 'text-gray-600']">
            Libre
          </div>
        </div>
        <div @click="setQuestionContributionsLimit(10)" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.questionContributionsLimit === 10"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions10On.svg"
            alt="Contributions 10 on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions10Off.svg"
            alt="Contributions 10 off"
          />
          <div class="pt-1" :class="[question.questionContributionsLimit === 10 ? 'text-white' : 'text-gray-600']">
            10
          </div>
        </div>
        <div @click="showOtherQuestionInput = true" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="!['free', 10, 20, 30, 40].includes(question.questionContributionsLimit)"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributionsOtherOn.svg"
            alt="Contributions Other on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributionsOtherOff.svg"
            alt="Contributions Other off"
          />
          <div
            class="pt-1"
            :class="[
              !['free', 10, 20, 30, 40].includes(question.questionContributionsLimit) ? 'text-white' : 'text-gray-600',
            ]"
          >
            Autre
          </div>
        </div>
      </div>
      <div v-if="!showOtherQuestionInput" class="flex justify-between px-4 pb-2">
        <div @click="setQuestionContributionsLimit(20)" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.questionContributionsLimit === 20"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions20On.svg"
            alt="Contributions 20 on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions20Off.svg"
            alt="Contributions 20 off"
          />
          <div class="pt-1" :class="[question.questionContributionsLimit === 20 ? 'text-white' : 'text-gray-600']">
            20
          </div>
        </div>
        <div @click="setQuestionContributionsLimit(30)" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.questionContributionsLimit === 30"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions30On.svg"
            alt="Contributions 30 on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions30Off.svg"
            alt="Contributions 30 off"
          />
          <div class="pt-1" :class="[question.questionContributionsLimit === 30 ? 'text-white' : 'text-gray-600']">
            30
          </div>
        </div>
        <div @click="setQuestionContributionsLimit(40)" class="flex flex-col items-center cursor-pointer">
          <img
            v-if="question.questionContributionsLimit === 40"
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions40On.svg"
            alt="Contributions 40 on"
          />
          <img
            v-else
            class="ml-2 w-8 h-8 cursor-pointer"
            src="../../assets/icons/contributions40Off.svg"
            alt="Contributions 40 off"
          />
          <div class="pt-1" :class="[question.questionContributionsLimit === 40 ? 'text-white' : 'text-gray-600']">
            40
          </div>
        </div>
      </div>
      <div v-else class="pt-3 px-5">
        Limite
        <input
          v-model="questionOther"
          ref="questionOther"
          class="w-28 px-2 bg-gray-700 text-white focus:outline-none placeholder-gray-600"
          type="text"
          placeholder="Nombre"
        />
        <img
          class="w-6 h-6 inline-block mr-4 cursor-pointer"
          src="../../assets/icons/edit.svg"
          alt="Valider"
          @click="
            setQuestionContributionsLimit(parseInt(questionOther))
            showOtherQuestionInput = false
          "
        />
        <img
          class="w-4 h-4 inline-block cursor-pointer"
          src="../../assets/icons/close.svg"
          alt="Annuler"
          @click="showOtherQuestionInput = false"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Toggle from "../utils/Toggle"

export default {
  data() {
    return {
      showOtherAttenteesInput: false,
      showOtherQuestionInput: false,
      attendeesOther: null,
      questionOther: null,
    }
  },
  computed: {
    ...mapState({
      question: (state) => state.question,
    }),
  },
  methods: {
    ...mapMutations("question", [
      "toggleIsAttendeesContributionsLimitByLabel",
      "setAttendeesContributionsLimit",
      "toggleIsQuestionContributionsLimitByLabel",
      "setQuestionContributionsLimit",
    ]),
  },
  watch: {
    showOtherAttenteesInput() {
      if (this.showOtherAttenteesInput === true) {
        this.$nextTick(() => {
          this.$refs.attendeesOther.focus()
        })
      }
    },
    showOtherQuestionInput() {
      if (this.showOtherQuestionInput === true) {
        this.$nextTick(() => {
          this.$refs.questionOther.focus()
        })
      }
    },
  },
  components: {
    Toggle,
  },
}
</script>

<style></style>
